module.exports = __webpack_public_path__ + "/dist/assets/images/pexels-photo-277253.jpeg";